import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../apiServices/apiClient';


function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/forgot-password', { email });
      navigate('/reset-password', { state: { email } });
    } catch (err) {
      setError('Usuário não cadastrado. Fale com seu Administrador.');
    }
  };

  return (    

<div className="flex min-h-screen">
{/* Lado esquerdo com logo */}
<div className="w-1/2 bg-white flex items-center justify-center">
  <div className="text-center">
    <img src="/public/assets/logo-mesaclick.png" alt="MesaClick Logo" className="mx-auto w-90" />
  </div>
</div>

{/* Lado direito com formulário */}
<div className="w-1/2 bg-blue-600 text-white flex items-center justify-center">
  <div className="w-full max-w-md px-8 py-12 bg-blue-700 rounded-xl shadow-lg">
    <h2 className="text-2xl font-bold mb-8 text-center">Esqueci minha senha!!!</h2>
    <h2 className="text-1xl font-bold mb-8 text-center">Entre com seu email de cadastro.</h2>
    <form onSubmit={handleSubmit}>
      <label className="block text-sm font-medium mb-1">Email</label>
      <input
        type="email"
        placeholder="Digite seu email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className="w-full px-4 py-2 mb-4 rounded text-black"
      />      

      <button
        type="submit"
        className="w-full bg-white text-blue-700 font-bold py-2 px-4 rounded hover:bg-gray-100"
      >
        Continuar
      </button>
      
    </form>
    {error && <p className="error">{error}</p>}
  </div>
</div>
</div>
  );
}

export default ForgotPassword;
